import React from 'react';
import ButtonChoice from '../Fields/ButtonChoice';

const AddonSelection = React.createClass({
    propTypes: {
        field: React.PropTypes.string.isRequired,
        regenerateQuote: React.PropTypes.func,
    },

    regenerateQuote : function() {
        this.props.regenerateQuote();
    },

    render() {
        return (
            <div>
                <ButtonChoice
                    question={''}
                    questionId={0}
                    fieldName={this.props.field}
                    loadCachedValue={true}
                    children={[]}
                    supplementaryText={null}
                    supplementaryTextAfterInput={null}
                    alternateBackground={null}
                    noBorder={null}
                    onChangeTertiary={this.regenerateQuote}
                    helpText={null}
                    showValidation={false}
                    options={[
                        {
                            option_text: 'Yes',
                            option_value: 'yes'
                        },
                        {
                            option_text: 'No',
                            option_value: 'no'
                        },
                    ]} />
            </div>
        );
    }
});

export default AddonSelection;



/** WEBPACK FOOTER **
 ** ./src/components/QuoteSummaryFields/AddonSelection.js
 **/